/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetUsersResponseDataUsersInnerUserAvatar,
  GetUsersResponseDataUsersInnerUserAvatarFromJSON,
  GetUsersResponseDataUsersInnerUserAvatarFromJSONTyped,
  GetUsersResponseDataUsersInnerUserAvatarToJSON
} from './GetUsersResponseDataUsersInnerUserAvatar'
import { UserProfile, UserProfileFromJSON, UserProfileFromJSONTyped, UserProfileToJSON } from './UserProfile'

/**
 *
 * @export
 * @interface GetUsersResponseDataUsersInner
 */
export interface GetUsersResponseDataUsersInner {
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInner
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInner
   */
  opportunityToolUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInner
   */
  userName?: string
  /**
   *
   * @type {GetUsersResponseDataUsersInnerUserAvatar}
   * @memberof GetUsersResponseDataUsersInner
   */
  userAvatar?: GetUsersResponseDataUsersInnerUserAvatar
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInner
   */
  organizationName?: string
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInner
   */
  position?: string | null
  /**
   *
   * @type {UserProfile}
   * @memberof GetUsersResponseDataUsersInner
   */
  userProfile?: UserProfile
}

export function GetUsersResponseDataUsersInnerFromJSON(json: any): GetUsersResponseDataUsersInner {
  return GetUsersResponseDataUsersInnerFromJSONTyped(json, false)
}

export function GetUsersResponseDataUsersInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUsersResponseDataUsersInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    opportunityToolUrl: !exists(json, 'opportunity_tool_url') ? undefined : json['opportunity_tool_url'],
    userName: !exists(json, 'user_name') ? undefined : json['user_name'],
    userAvatar: !exists(json, 'user_avatar')
      ? undefined
      : GetUsersResponseDataUsersInnerUserAvatarFromJSON(json['user_avatar']),
    organizationName: !exists(json, 'organization_name') ? undefined : json['organization_name'],
    position: !exists(json, 'position') ? undefined : json['position'],
    userProfile: !exists(json, 'user_profile') ? undefined : UserProfileFromJSON(json['user_profile'])
  }
}

export function GetUsersResponseDataUsersInnerToJSON(value?: GetUsersResponseDataUsersInner | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    opportunity_tool_url: value.opportunityToolUrl,
    user_name: value.userName,
    user_avatar: GetUsersResponseDataUsersInnerUserAvatarToJSON(value.userAvatar),
    organization_name: value.organizationName,
    position: value.position,
    user_profile: UserProfileToJSON(value.userProfile)
  }
}
